import { z } from "zod";

export const educationSchema = z.object({
  "School Name": z.string(),
  "Start Date": z.string().optional(),
  "End Date": z.string().optional(),
  Notes: z.string().optional(),
  "Degree Name": z.string().optional(),
  Activities: z.string().optional(),
});
